const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Workshop Host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('workshopHost', ['Application', 'Authorization', 'Workshops', 'UserWorkshops', 'Analyze', '$q', '$translate', function (Application, Authorization, Workshops, UserWorkshops, Analyze, $q, $translate) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../templates/directives/workshop-host.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      const multiworkshopID = routeParameters.mswid;
      self.user = Authorization.getAuthToken().user;
      
      self.languageAsVirtual = false;
      if(Application.LAYOUT === 'lyft'){
        self.languageAsVirtual = true ;
      };

      self.getRating = function(item) {
        if (item.average_rating) {
          var outOfFive = Math.round(item.average_rating * 5) / 100;
          if (outOfFive) {
            return outOfFive;
          }
        }

        return '----';
      };

      self.reporting = {
        allSelected: false,
        selections: [],
        activeLink: '',
        allDateLink: Application.API + '/learn/v3/workshops/report/' + routeParameters.id + '?authtoken=' + Authorization.getAuthToken().authtoken + '&instances=all',
        select: function(item) {
          var idx = self.reporting.selections.indexOf(item._id);
          if (idx === -1) {
            self.reporting.selections.push(item._id);
            self.reporting.setLink();
            return;
          }
          self.reporting.selections.splice(idx, 1);
          self.reporting.setLink();
        },
        setLink: function() {
          if (self.reporting.selections.length || self.reporting.allSelected) {
            var instances = self.reporting.selections.join(',');
            if (self.reporting.allSelected) {
              instances = [];
              self.instances.list.forEach(function(instance) {
                if (instance._id) {
                  instances.push(instance._id);
                }
              });
              instances.join(',');
            }
            self.reporting.activeLink = Application.API + '/learn/v3/workshops/report/' + routeParameters.id + '?authtoken=' + Authorization.getAuthToken().authtoken + '&instances=' + instances;
            return;
          }
          self.reporting.activeLink = '';
        },
        linkClicked: function() {
          self.reporting.clicked = true;
          setTimeout(function() {
            self.reporting.clicked = false;
            $scope.$apply();
          }, 5000);
        },
        isSelected: function(item) {
          if (!item || !item._id) {
            return false;
          }
          return self.reporting.allSelected || self.reporting.selections.indexOf(item._id) !== -1;
        }
      };

      self.info = {
        loading: false,
        totals: {
          attended: 0,
          registered: 0,
          dates: 0,
          waiting: 0
        },
        routeInstanceId: null,
        showStats: function() {
          if (self.info.totals.dates || self.info.totals.registered || self.info.totals.attended || self.info.totals.waiting) {
            return true;
          }
          return false;
        },
        multipleInstances: true,
        activeInstance: false,
        viewInstance: function(instance) {
          if (!instance._id) {
            return;
          }
          this.activeInstance = instance;
          this.activeInstance.data = self.instances.data[self.info.activeInstance._id];
          self.instances.registrationDownload = Application.API + '/learn/v3/user-workshops/workshop-instance/' + instance._id + '/registration-csv?authtoken=' + Authorization.getAuthToken().authtoken;
          self.instances.waitlistDownload = Application.API + '/learn/v3/user-workshops/workshop-instance/' + instance._id + '/waitlist-csv?authtoken=' + Authorization.getAuthToken().authtoken;
        },
        goToWorkshop: function() {
          Application.navigation.goTo('view/workshops/' + self.workshop._id)
        },
        editWorkshop: function() {
          if (self.workshop.type === 'multi_session_workshop_session'){
            Application.navigation.goTo('edit/multi-session-workshops/' + multiworkshopID + '/session/' + self.workshop._id);
          } else {
            Application.navigation.goTo('edit/workshops/' + self.workshop._id);
          }
        },
        backToHost: function() {
          self.info.activeInstance = false;
          if (self.info.routeInstanceId) {
            Application.navigation.goTo('host/workshops/' + self.workshop._id);
          }
        },
        requestDisable: function() {
          if (self.workshop.registration_disabled) {
            self.info.changeRegistration();
            return;
          }
          self.info.registrationDisable = true;
        },
        changeRegistration: function() {
          var action = self.workshop.registration_disabled ? 'enable' : 'disable';
          self.info.loading = true;
          Workshops.update({subresource: self.workshop._id, fields: 'registration_disabled,auto_populate_disabled'}, {
           registration_disabled: action === 'disable' ? true : false,
           auto_populate_disabled: action === 'disable' ? true : false
          }).$promise
          .then(function(data) {
            self.info.registrationDisable = false;
            Analyze.record({resource: 'modifications'}, {document: self.workshop._id, type: 'workshop'});
            Application.analyticsProvider.trackEvent('workshop_updated', {content: self.workshop._id, type: 'workshop', title: self.workshop.title});
            Application.messaging.addMessage({type: 'success', duration: 3, text: 'Registration ' + (action === 'disable' ? 'disabled' : 'enabled') + '.'});
            self.workshop.registration_disabled = data.registration_disabled;
            self.workshop.auto_populate_disabled = data.auto_populate_disabled;
            self.info.loading = false;
          }).catch(function(error) {
            $translate('workshopHost.unable_to_save').then(function (translation) {
              Application.messaging.addMessage({type: 'error', text: translation, duration: 5});
            });
            self.info.loading = false;
          });
        }
      };
      self.instances = {
        list: [],
        nextAvailable: false,
        data: {},
        allInstances: [],
        addUsers: false,
        waitUsers: false,
        registrationDownload: '',
        waitlistDownload: '',
        registrationClicked: false,
        waitlistClicked: false,
        instanceTab: '',
        rangeTab: 'future',
        query: {
          useropt: routeParameters.id,
          fields: 'workshop,seats,waitlist_seats,allow_waitlist,start_date,end_date,host,location,online,notes,post_message_sent,recordings,average_rating,type,zoom_settings,zoom_summary',
          page: 1,
          per_page: 10,
          sort: 'start_date,1'
        },
        load: function() {
          self.info.loading = true;
          self.comms.getParticipation(self.instances.query).then(function(data) {
            self.instances.organize(data);
            self.info.loading = false;
          }).catch(function(error) {
            // handle error
            console.log('error in getParticipation data');
            self.info.loading = false;
          });
        },
        organize: function(chunk) {
          self.instances.nextAvailable = false;
          self.instances.list = chunk?.instances || [];
          self.instances.allInstances = chunk?.allInstances || [];
          if (self.instances.list && self.instances.list.length >= self.instances.query.per_page) {
            self.instances.nextAvailable = true;
          }
          self.instances.data = {};
          if (chunk && chunk.data && chunk.data.length) {
            chunk.data.forEach(function(item) {
              self.instances.data[item._id] = item;
            });
          }
          if (self.instances.nextSwitch) { 
            self.instances.nextAvailable = false;
            self.instances.nextSwitch = false;
          }
          if (self.instances.list.length === 0 && self.instances.query.page > 1) {
            self.instances.nextSwitch = true;
            self.instances.previous();
          }

          for (var i = self.instances.list.length - 1; i >= 0; i--) {
            var now =  new Date();
            var instanceDate = new Date(self.instances.list[i].start_date);
            if (self.instances.rangeTab === 'future') {
              if (instanceDate < now) {
                self.instances.list.splice(i, 1);
                continue;
              }
            }
            if (self.instances.rangeTab === 'past') {
              if (instanceDate > now) {
                self.instances.list.splice(i, 1);
                continue;
              }
            }
          }
        },
        nextSwitch: false,
        tabSwitch: function(tab) {
          if (self.instances.rangeTab === tab) {
            return;
          }
          self.instances.rangeTab = tab;
          self.instances.query.page = 1;
          self.instances.load();
        },
        next: function() {
          if (!self.instances.nextAvailable) {
            return;
          }
          self.instances.query.page++;
          self.instances.load();
        },
        previous: function() {
          if (self.instances.query.page <= 1) {
            return;
          }
          self.instances.query.page--;
          self.instances.load();
        },
        updateTotals: function(instanceData) {
          self.comms.getTotals()
          .then(function(data) {
            self.info.totals = data;
          });
          if (instanceData && instanceData._id) {
            for (var key in self.instances.data) {
              if (key === instanceData._id) {
                self.instances.data[key].attendences = instanceData.attended;
                self.instances.data[key].registrations = instanceData.registered;
                self.instances.data[key].waitlists = instanceData.waiting;
              }
            }
          }
        }
      };

      self.comms = {
        initializing: false,
        initialize: async function() {
          self.comms.initializing = true;
          const data = await $q.all([
            self.comms.getWorkshop(),
            self.comms.getParticipation(self.instances.query),
            self.comms.getTotals()
          ]);
          self.instances.organize(data[1]);
          self.workshop = data[0];
          self.workshop.msw = routeParameters.mswid;
          self.allowRating = self.workshop && self.workshop.rating_configuration && self.workshop.rating_configuration.allow_rating;
          if (self.workshop.average_rating) {
            var outOfFive = Math.round(self.workshop.average_rating / 10 * 5) / 10;
            if (outOfFive) {
              self.rating = outOfFive + '/5';
            }
          }
          self.info.totals = data[2];
          if (data[1] && data[1].instances && data[1].instances.length > 0) {
            self.info.multipleInstances = true;
          }

          if (routeParameters.instanceId) {
            self.info.routeInstanceId = routeParameters.instanceId;
            const routeInstance = self.instances.allInstances.find((instance) => instance._id === self.info.routeInstanceId);
            if (routeInstance) {
              self.info.viewInstance(routeInstance);
              self.comms.initializing = false;
              return;
            }
          }
          
          self.info.noWorkshops = true;
          self.comms.initializing = false;
          $scope.$apply();
          return;
        },
        getWorkshop: function() {
          return Workshops.get({subresource: routeParameters.id, fields: 'title,registration_disabled,auto_populate_disabled,post_messaging_options,average_rating,rating_configuration,type'}).$promise;
        },
        getParticipation: function(query) {
          if (self.instances.rangeTab === 'future') {
            query.start_date = '$gte,date-' + moment().utc().format('MM-DD-YY');
          }
          if (self.instances.rangeTab === 'past') {
            query.start_date = '$lt,date-' + moment().utc().add('days', 1).format('MM-DD-YY');
          }
          return UserWorkshops.overview(query).$promise;
        },
        getTotals: function(query) {
          return UserWorkshops.workshopTotals({userid: routeParameters.id}).$promise;
        }
      };

      self.comms.initialize();

    }],
    controllerAs: 'host'
  }
}]);
